// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"8d95bf2c","14":"b72ccec3","38":"c8b3b692","134":"a33d4376","449":"ca348215","617":"583db1ff","659":"e39cb0b9","758":"70c3eb63","778":"5a0beb2c","912":"f5420de4"}[chunkId] + ".chunk.js";
};